import { Cordova, Electron } from 'pos/common';
import { Res } from 'core/api';

import { showExternalUrlDialog } from './showExternalUrlDialog';
import { ExternalActionFlow } from './ExternalActionFlow';
import { Result } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';

export type ExecuteExternalActionParams = {
	title: string;
	imageSrc: string;
	action: string;
	showUrlInEmbeddedViewer: boolean;
	args: {
		userId: Nullable<number>;
		posId: Nullable<number>;
		ticketId: Nullable<number>;
		ticketGlobalId: Nullable<string>;
		ticketLineIndex: Nullable<number>;
	};
};

export async function executeExternalAction(params: ExecuteExternalActionParams): Promise<Result<ExternalActionFlow>> {
	if (isUrl(params.action)) {
		return await launchUrl(params);
	}
	else {
		await launchProgram(params);
		return Result.ok('none');
	}
}

async function launchUrl({ title, imageSrc, action, args, showUrlInEmbeddedViewer }: ExecuteExternalActionParams): Promise<Result<ExternalActionFlow>> {

	const replacements = [
		['user_id', args.userId],
		['pos_id', args.posId],
		['ticket_id', args.ticketId],
		['ticket_global_id', args.ticketGlobalId],
		['ticket_line_index', args.ticketLineIndex]
	];

	for (const [placeholder, value] of replacements) {
		action = action.replace(`{${placeholder}}`, sanitizeValue(value));
	}

	if (showUrlInEmbeddedViewer) {
		return await showExternalUrlDialog({ title, iconSrc: imageSrc, url: action });
	}
	else {
		// A Safari no le gusta que abramos pesta�as nuevas, as� que nos toca meterlo en un setTimeOut
		// https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
		setTimeout(async () => {

			if (Cordova.isCordovaNavigator())
				await Cordova.openUrl(action);
			else
				window.open(action);
		});
		return Result.ok('none');
	}
}

async function launchProgram({ action, args }: ExecuteExternalActionParams): Promise<void> {
	if (!Electron.isEnabled()) {
		await Message.show(Res.Msg.MSG_ELECTRON_IS_REQUIRED_TO_RUN_EXTERNAL_COMMANDS());
		return;
	}

	const env: Record<string, string> = {
		AGORA_USER_ID: sanitizeValue(args.userId),
		AGORA_POS_ID: sanitizeValue(args.posId),
		AGORA_TICKET_ID: sanitizeValue(args.ticketId),
		AGORA_TICKET_GLOBAL_ID: sanitizeValue(args.ticketGlobalId),
		AGORA_TICKET_LINE_INDEX: sanitizeValue(args.ticketLineIndex),
	};

	await Electron.ProcessManager.start(action, env);
}

function isUrl(action: string): boolean {
	return action.startsWith('http://') || action.startsWith('https://');
}

function sanitizeValue(value: string | number | null): string {
	return value === null ? '' : value.toString();
}